import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=662eb8c2&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=js&"
export * from "./FileEditor.vue?vue&type=script&lang=js&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=662eb8c2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662eb8c2",
  null
  
)

export default component.exports